import React from "react";
import "./ReportHeader.css";

const ReportHeader = ({
    year, setYear, years,
    states, selectedStates, handleStateChange, showStates, setShowStates, stateSearch, setStateSearch, statesError,
    lgas, selectedLgas, handleLgaChange, showLgas, setShowLgas, lgaSearch, setLgaSearch, lgasError,
    resetFilters, handleExport, exportLoading
}) => {
    const filteredStates = states.filter(s => s.name.toLowerCase().includes(stateSearch.toLowerCase()));
    const filteredLgas = lgas.filter(l => l.name.toLowerCase().includes(lgaSearch.toLowerCase()));

    return (
        <header className="report-header">
            <h1>Budget & Financial Reports</h1>
            <div className="report-filters">

                {/* Year */}
                <select className="report-header-select" value={year} onChange={(e) => setYear(e.target.value)}>
                    <option value="">Select Year</option>
                    {years.map((y) => (
                        <option key={y} value={y}>
                            {y}
                        </option>
                    ))}
                </select>

                {/* States */}
                <div className={`state-checkboxes ${showStates ? "active" : ""}`}>
                    <div onClick={() => setShowStates(prev => !prev)}>
                        {showStates ? "Hide States" : "Filter by State"}
                    </div>
                    {showStates && (
                        <>
                            <input type="text" placeholder="Search states..." value={stateSearch} onChange={(e) => setStateSearch(e.target.value)} className="filter-search-input" />
                            {statesError && <p className="filter-error">Failed to load states</p>}
                            <div className="state-checkboxes-list">
                                {filteredStates.map(state => (
                                    <label key={state._id}>
                                        <input type="checkbox" checked={selectedStates.includes(state._id)} onChange={() => handleStateChange(state._id)} />
                                        {state.name}
                                    </label>
                                ))}
                            </div>
                        </>
                    )}
                </div>

                {/* LGAs */}
                <div className={`lga-checkboxes ${showLgas ? "active" : ""}`}>
                    <div onClick={() => setShowLgas(prev => !prev)}>
                        {showLgas ? "Hide LGAs" : "Filter by LGA"}
                    </div>
                    {showLgas && (
                        <>
                            <input type="text" placeholder="Search LGAs..." value={lgaSearch} onChange={(e) => setLgaSearch(e.target.value)} className="filter-search-input" />
                            {lgasError && <p className="filter-error">Failed to load LGAs</p>}
                            <div className="lga-checkboxes-list">
                                {filteredLgas.map(lga => (
                                    <label key={lga._id}>
                                        <input type="checkbox" checked={selectedLgas.includes(lga._id)} onChange={() => handleLgaChange(lga._id)} />
                                        {lga.name}
                                    </label>
                                ))}
                            </div>
                        </>
                    )}
                </div>

                {/* Reset */}
                <button className="btn-reset-filters" onClick={resetFilters}>Reset Filters</button>

                {/* Export */}
                <div className="export-dropdown">
                    <button>{exportLoading ? "Exporting..." : "Export ▼"}</button>
                    <div className="dropdown-content">
                        <p onClick={() => handleExport("excel")}>Excel</p>
                        {/* <p onClick={() => handleExport("pdf")}>PDF</p> */}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default ReportHeader;